export enum CatalogItemTab {
  Description = 'Описание',
  Complex = 'Состав комплекса',
  Preparations = 'Подготовка к анализу',
  Indications = 'Показания к назначению',
}
